export interface TutorialStep {
  title: string
  image: string
  description: string
}

export const TUTORIAL_STEPS = [
  {
    title:
      'デザインシミュレータを使って \n 商品に印刷した時のイメージを見てみましょう',
    image: 'landing-modal-img-1',
    description:
      'ロゴやイラストなどの画像をアップロードして使うことができます'
  },
  {
    title:
      '画像と商品を選ぶと \n 印刷した時のイメージを確認できます',
    image: 'landing-modal-img-2',
    description:
      '画面の左側では、表示する画像や商品を切り替えることができます'
  },
  {
    title:
      '本体色や印刷する場所を切り替えて \n いろいろな組み合わせを見ることができます',
    image: 'landing-modal-img-3',
    description:
      '右側の画面では、本体色や印刷する場所を切り替えることができます'
  },
  {
    title: 'カテゴリを変更すると \n 他の商品に印刷した時のイメージを表示できます',
    image: 'landing-modal-img-4',
    description: '印刷可能なすべての商品で印刷した時のイメージを見ることができます'
  },
  {
    title: '気になる商品が見つかりますように！ \n デザインシミュレータをお楽しみください',
    image: 'landing-modal-img-5',
    description: '登録した画像は保存され、次回以降もデザインシミュレータやご注文時にお使いいただけます'
  }
]
